// //OrderingPage.js
// import React, { useState } from 'react';
// import CustomerOrderSelection from './CustomerOrderSelection';
// import ItemSelection from './ItemSelection';
// import AddressConfirmation from './AddressConfirmation';
// // import Head from '../order/header';
// import { Card, Form, Row, Col, Radio } from 'antd';


// function OrderingPage() {


//   const [selectedOption, setSelectedOption] =  useState(null);
//   const [orderType, setOrderType] = useState(null);
//   const [customerOrderData, setCustomerOrderData] = useState(null);


//   const [itemSelectionData, setItemSelectionData] = useState(null);
//   const [addressConfirmationData, setAddressConfirmationData] = useState(null);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [currentStage, setCurrentStage] = useState(1);

//   const [invoiceSubtotalValue, setInvoiceSubtotalValue] = useState([]);
//     const [qtyvalue, setQTYValue] = useState([]);
//     const [filteredLabel, setFilteredLabel] = useState([]);
//     const [filteredValue, setFilteredValue] = useState([]);
//     const [invoiceTotalValue, setInvoiceTotalValue] = useState([]);
//   const [anyLocationChecked, setAnyLocationChecked] = useState(null);

  
//   const handleCustomerOrderData = (data) => {
//     setSelectedOption(data.selectedOption); // Store the selected customer
//     setOrderType(data.orderType);
//     setAnyLocationChecked(data.anyLocationChecked);

//     console.log('handleCustomerOrderData ', data);
//     setCustomerOrderData(data);
//     setCurrentStage(2);
//   };

  
//   const handleItemSelectionData = (data) => {
//     setItemSelectionData(data);
    
//   console.log('secont page.......1 ', data);
//   setInvoiceSubtotalValue(data.invoiceSubtotal);
//   setQTYValue(data.qty);
//   setFilteredLabel(data.filteredLabel);
//   setFilteredValue(data.filteredValue);
//   setInvoiceTotalValue(data.invoiceTotal);
//   setSelectedItems(data.selectedItems); // Set selectedItems here
//     setCurrentStage(3);
//   };

//   const handleAddressConfirmationData = (data) => {
//     setAddressConfirmationData(data);
//   };

//   const handleSelectedItemsChange = (items) => {
//     setSelectedItems(items);
//   };

//   // const handleBack = () => {
//   //   if (currentStage === 3) setCurrentStage(2);
//   //   else if (currentStage === 2) setCurrentStage(1);
//   // };

//   const handleBack = (data) => {
//     if (currentStage === 3) {
//       setCurrentStage(2);
//       if (data.selectedData) {
//         setSelectedItems(data.selectedData);
//         setInvoiceSubtotalValue(invoiceSubtotalValue);
//         setQTYValue(qtyvalue);
//         setInvoiceTotalValue(data.selectedItems);
//       }
//     } else if (currentStage === 2) {
//       setCurrentStage(1);
//       // if (data.selectedData) {
//         setSelectedItems('');
//         setInvoiceSubtotalValue('');
//         setQTYValue('');
//         setInvoiceTotalValue('');
//       // }
//   }
//   };

//   const handleBack1 = () => {
//     if (currentStage === 3) {
//       setCurrentStage(1);
//       // if (data.selectedData) {
//         setSelectedItems('');
//         setInvoiceSubtotalValue('');
//         setQTYValue('');
//         setInvoiceTotalValue('');
//     }
//   };

//   // const handleBack = (data) => {
//   //   console.log("handleBack clicked");
//   //   console.log("Current stage:", currentStage);
//   //   if (currentStage === 3 || currentStage === 2) {
//   //     setCurrentStage(currentStage - 1);
//   //     console.log("New stage:", currentStage - 1);
//   //     if (data) {
//   //       console.log('Data received:', data);
//   //       console.log('Data received111:', data.selectedData);
//   //       console.log('Data received112:', invoiceSubtotalValue);
//   //       console.log('Data received113:', qtyvalue);
//   //       console.log('Data received114:', invoiceTotalValue);
//   //       // setInvoiceSubtotalValue(data.invoiceSubtotalValue);
//   //       // setQTYValue(data.qtyvalue);
//   //       // setInvoiceTotalValue(data.invoiceTotalValue);
//   //       if (data.selectedData) {
//   //         setSelectedItems(data.selectedData);
//   //         setInvoiceSubtotalValue(invoiceSubtotalValue);
//   //         setQTYValue(qtyvalue);
//   //         setInvoiceTotalValue(data.selectedItems);
//   //       }
//   //     }
//   //   }
//   // };
  

//   return (
//     <div>
//         {/* const { stage } = this.state; */}
//         <Form.Item
//         wrapperCol={{
//           offset: 7,
//           span: 10,
//         }}
//         name={['id']}
//         noStyle
//         rules={[
//           {
//             required: true,
//             //message: 'Item Id id required',
//           },
//         ]}
//       >
//         {/* <Head></Head> */}
//       </Form.Item>

//       {currentStage === 1 && <CustomerOrderSelection onNext={handleCustomerOrderData}  />}
//       {currentStage === 2 && <ItemSelection onPrev={handleBack} onNext={handleItemSelectionData} selectedOption={selectedOption} orderType={orderType} selectedData={selectedItems} invoiceSubtotalValue={invoiceSubtotalValue} qtyvalue={qtyvalue} invoiceTotalValue={invoiceTotalValue} anyLocationChecked={anyLocationChecked}  />}
//       {currentStage === 3 && <AddressConfirmation onPrev={handleBack1} onBack={handleBack} onConfirm={handleAddressConfirmationData} selectedOption={selectedOption} orderType={orderType} selectedData={selectedItems} invoiceSubtotalValue={invoiceSubtotalValue} qtyvalue={qtyvalue} invoiceTotalValue={invoiceTotalValue} filteredLabel={filteredLabel} filteredValue={filteredValue} anyLocationChecked={anyLocationChecked}/>}
//     </div>
//   );
// }

// export default OrderingPage;
// OrderingPage.js
import React, { useState } from 'react';
import CustomerOrderSelection from './CustomerOrderSelection';
import ItemSelection from './ItemSelection';
import AddressConfirmation from './AddressConfirmation';
// import Head from '../order/header';
import { Card, Form, Row, Col, Radio } from 'antd';

function OrderingPage() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [customerOrderData, setCustomerOrderData] = useState(null);
  const [itemSelectionData, setItemSelectionData] = useState(null);
  const [addressConfirmationData, setAddressConfirmationData] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentStage, setCurrentStage] = useState(1);

  const [invoiceSubtotalValue, setInvoiceSubtotalValue] = useState([]);
  const [qtyvalue, setQTYValue] = useState([]);
  const [filteredLabel, setFilteredLabel] = useState([]);
  const [filteredValue, setFilteredValue] = useState([]);
  const [invoiceTotalValue, setInvoiceTotalValue] = useState([]);
  const [anyLocationChecked, setAnyLocationChecked] = useState(null);
  
  // ADD DOCUMENT STATE
  const [uploadedDocuments, setUploadedDocuments] = useState({});

  const handleCustomerOrderData = (data) => {
    setSelectedOption(data.selectedOption);
    setOrderType(data.orderType);
    setAnyLocationChecked(data.anyLocationChecked);
    console.log('handleCustomerOrderData ', data);
    setCustomerOrderData(data);
    setCurrentStage(2);
  };

  const handleItemSelectionData = (data) => {
    setItemSelectionData(data);
    console.log('second page.......1 ', data);
    setInvoiceSubtotalValue(data.invoiceSubtotal);
    setQTYValue(data.qty);
    setFilteredLabel(data.filteredLabel);
    setFilteredValue(data.filteredValue);
    setInvoiceTotalValue(data.invoiceTotal);
    setSelectedItems(data.selectedItems);
    
 
    setUploadedDocuments(data.uploadedDocuments || {});
    
    setCurrentStage(3);
  };

  const handleAddressConfirmationData = (data) => {
    setAddressConfirmationData(data);
  };

  const handleSelectedItemsChange = (items) => {
    setSelectedItems(items);
  };

  const handleBack = (data) => {
    if (currentStage === 3) {
      setCurrentStage(2);
      if (data.selectedData) {
        setSelectedItems(data.selectedData);
        setInvoiceSubtotalValue(invoiceSubtotalValue);
        setQTYValue(qtyvalue);
        setInvoiceTotalValue(data.selectedItems);
        if (data.uploadedDocuments) {
            console.log('data back 1',data.uploadedDocuments);
            setUploadedDocuments(data.uploadedDocuments);
        }
    }
    } else if (currentStage === 2) {
      setCurrentStage(1);
      setSelectedItems('');
      setInvoiceSubtotalValue('');
      setQTYValue('');
      setInvoiceTotalValue('');
      setUploadedDocuments({});
    }
  };

  const handleBack1 = () => {
    if (currentStage === 3) {
      setCurrentStage(1);
      setSelectedItems('');
      setInvoiceSubtotalValue('');
      setQTYValue('');
      setInvoiceTotalValue('');
      setUploadedDocuments({});
    }
  };

  return (
    <div>
      <Form.Item
        wrapperCol={{
          offset: 7,
          span: 10,
        }}
        name={['id']}
        noStyle
        rules={[
          {
            required: true,
          },
        ]}
      >
        {/* <Head></Head> */}
      </Form.Item>

      {currentStage === 1 && <CustomerOrderSelection onNext={handleCustomerOrderData} />}
      {currentStage === 2 && (
        <ItemSelection 
          onPrev={handleBack} 
          onNext={handleItemSelectionData} 
          selectedOption={selectedOption} 
          orderType={orderType} 
          selectedData={selectedItems} 
          invoiceSubtotalValue={invoiceSubtotalValue} 
          qtyvalue={qtyvalue} 
          invoiceTotalValue={invoiceTotalValue} 
          anyLocationChecked={anyLocationChecked}  
           uploadedDocuments={uploadedDocuments}
        />
      )}
      {currentStage === 3 && (
        <AddressConfirmation 
          onPrev={handleBack1} 
          onBack={handleBack} 
          onConfirm={handleAddressConfirmationData} 
          selectedOption={selectedOption} 
          orderType={orderType} 
          selectedData={selectedItems} 
          invoiceSubtotalValue={invoiceSubtotalValue} 
          qtyvalue={qtyvalue} 
          invoiceTotalValue={invoiceTotalValue} 
          filteredLabel={filteredLabel} 
          filteredValue={filteredValue} 
          anyLocationChecked={anyLocationChecked}
          // PASS UPLOADED DOCUMENTS TO ADDRESS CONFIRMATION
          uploadedDocuments={uploadedDocuments}
        />
      )}
    </div>
  );
}

export default OrderingPage;